import { defineStore } from "pinia";
import { ref } from 'vue';

export const useNotifications = defineStore('notifications', () => {
    const notifications = ref([])

    const clear = (index = null) => {
        if(! index) {
            notifications.value = []
            return
        }

        notifications.value = notifications.value.splice(index, 1)
    }

    const notify = (message, type = 'success', autodelete = 3500, url = null, actionText = null, actionClickCb = null) => {
        let index = notifications.value.push({ message, type, url, actionText, actionClickCb })
        if(! autodelete) return index

        setTimeout(() => {
            clear(index)
        }, autodelete)

        return index
    }
    
    return { notifications, notify, clear }
})
